import { HIDDEN } from '../classnames/design-system';
import Rejoiner from '../api/rejoiner';
import EmailValidator from '../form-validators/email';
import PresenceValidator from '../form-validators/presence';

import analytics from '../analytics';

export default class BaseEmailSubscriptionHandler {
  inputName = 'email';
  inputLabel = 'Email';
  rejoiner = new Rejoiner();

  constructor(container, formClassName, sectionClassName, successSectionClassName, buttonClassName, inputClassName) {
    this.container = container;
    this.formClassName = formClassName;
    this.sectionClassName = sectionClassName;
    this.successSectionClassName = successSectionClassName;
    this.buttonClassName = buttonClassName;
    this.inputClassName = inputClassName;

    if (this.container) {
      this.form = this.container.querySelector(`.${this.formClassName}`);
      this.subscribeSection = this.container.querySelector(`.${this.sectionClassName}`);
      this.successSection = this.container.querySelector(`.${this.successSectionClassName}`);
      this.button = this.container.querySelector(`.${this.buttonClassName}`);
      this.input = this.container.querySelector(`.${this.inputClassName}`);
    }

    this.initialize = this.initialize.bind(this);
    this.onSubmitSuccess = this.onSubmitSuccess.bind(this);
    this.subscribeToListParams = this.subscribeToListParams.bind(this);
  }

  handleSubmit = () => {
    const emailValidator = new EmailValidator(this.form, this.inputName, this.inputLabel);
    const presenceValidator = new PresenceValidator(this.form, this.inputName, this.inputLabel);

    if (presenceValidator.validate() && emailValidator.validate()) {
      this.onSubmitSuccess();
    }
  };

  showSection = () => {
    this.container.classList.remove(HIDDEN);
  };

  initializeEventListeners = () => {
    if (this.button) {
      this.button.addEventListener('click', this.handleSubmit);
    }
  };

  onSubmitSuccess() {
    this.rejoiner.subscribeToList(this.subscribeToListParams());
    this.successSection.classList.remove(HIDDEN);
    this.subscribeSection.classList.add(HIDDEN);

    if (!this.emailFromUrl) analytics.newsletterSubscribed({ email: this.input.value });
  }

  subscribeToListParams() {
    return ({
      email: this.input.value,
      listId: this.button.dataset.listId
    });
  }

  initialize() {
    if (this.container) {
      this.showSection();
      this.initializeEventListeners();
    }
  }
}
